import * as tslib_1 from "tslib";
import { ElementRef, OnInit } from '@angular/core';
import { ArrayHelper } from '../../../../models/helpers/array-helper';
import { BaseComponent } from '../../../core/components/bases/base-component';
import { takeUntil } from 'rxjs/operators';
import { ConfirmDeleteModalComponent } from '../../../core/components/delete-modal/confirm-delete-modal-component';
export class PhotosListComponent extends BaseComponent {
    constructor(collectionService, canDeactivateService, route, userService) {
        super();
        this.collectionService = collectionService;
        this.canDeactivateService = canDeactivateService;
        this.route = route;
        this.userService = userService;
        this.photos = [];
        this.validFileMimeTypes = ['image/jpeg', 'image/png'];
        this.showEditValidation = false;
    }
    set collection(value) {
        if (value && this._collection !== value) {
            this.siteArea.collections = [value, ...this.siteArea.collections.filter(c => c.id != value.id)];
        }
        this._collection = value;
        if (value && value.photos) {
            this.photos = this.sortPhotos(value.photos);
        }
        else {
            this.photos = [];
        }
    }
    ngOnInit() {
        this.getCurrentUser();
        this.route.paramMap.subscribe(params => {
            this.collection = this.siteArea.collections.find(c => c.id == this.collectionId);
        });
        this.wizardModal.onHidden.pipe(takeUntil(this.onDestroy$)).subscribe(() => this.files = undefined);
        this.editModal.onHidden.pipe(takeUntil(this.onDestroy$)).subscribe(() => this.editPhoto = undefined);
    }
    showFullscreen(photo) {
        this.fullscreenPhoto = photo;
        this.fullscreenModal.show();
    }
    filesSelected(fileList) {
        let files = [];
        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            if (this.validFileMimeTypes.includes(file.type))
                files.push(file);
        }
        if (files.length == 0)
            return;
        this.files = files;
        this.wizardModal.show();
    }
    closeWizard() {
        this.fileInput.nativeElement.value = '';
        this.wizardModal.hide();
    }
    closeEditModal() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let shouldShowConfirmLeaving = this.shouldShowConfirmLeaving();
            if (shouldShowConfirmLeaving) {
                let leaveThePage = yield this.canDeactivateService.showWarning();
                if (!leaveThePage)
                    return;
            }
            this.editModal.hide();
        });
    }
    shouldShowConfirmLeaving() {
        let isLatChange = this.oldLat != +this.editPhoto.lat;
        let isLngChange = this.oldLng != +this.editPhoto.lon;
        return isLatChange || isLngChange;
    }
    photoChanged(photo) {
        this._collection.photos = this.sortPhotos([Object.assign({}, photo), ...this.photos.filter(p => p.id != photo.id)]);
        this.photos = this._collection.photos;
    }
    sortPhotos(photos) {
        return ArrayHelper.sortBy(photos, false, p => new Date(p.lastUpdated));
    }
    showEdit(photo) {
        this.editPhoto = Object.assign({}, photo);
        this.editModal.show();
        this.oldLat = this.editPhoto.lat;
        this.oldLng = this.editPhoto.lon;
    }
    saveEdit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.editPhoto.lat || !this.editPhoto.lon) {
                this.showEditValidation = true;
                return;
            }
            this.editModal.hide();
            let photo = this.editPhoto;
            this.showEditValidation = false;
            yield this.collectionService.updatePhoto(photo);
            photo.lastUpdated = new Date();
            this.photoChanged(photo);
        });
    }
    setThumbnail(photo) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.collectionService.setCollectionThumbnail(this._collection.id, photo.id);
            this.collection = Object.assign({}, this._collection, { thumbnailPhotoId: photo.id });
        });
    }
    deletePhoto(photo) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let deleted = yield this.confirmDelete.showAwait(photo.id);
            if (!deleted)
                return;
            yield this.collectionService.deletePhoto(photo.id, this._collection.plantingSiteId);
            this._collection.photos = [...this.photos.filter(p => p.id != photo.id)];
            this.photos = this._collection.photos;
        });
    }
    getCurrentUser() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.currentUser = yield this.userService.getCurrentUserAsync();
        });
    }
}
